import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectsNotFoundRoute: InvariantJiraRoute = {
	name: 'projects-not-found',
	path: '/jira/projects/not-found',
	exact: true,
};
